import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import InlineModal from '../shared/InlineModal';

export default function NextGenImageFormatSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />
            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {['warning', 'failed'].includes(result.status) && (
                    <>
                        <NextGenImageResult unoptimizedImages={result.unoptimized_images} />

                        {result.how_to_fix && (
                            <HowToFix
                                title={title}
                                howToFix={result.how_to_fix}
                                howToFixVideo={result.how_to_fix_video}
                            />
                        )}
                    </>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type NextGenImageResultProps = {
    unoptimizedImages: {
        potential_savings: number;
        size: number;
        url: string;
    }[];
};

function NextGenImageResult({ unoptimizedImages }: NextGenImageResultProps) {
    return (
        <div className="description-meta">
            <InlineModal
                openLabel="See results list"
                modalTitle="Full list of unoptimized images"
                closeLabel="Close"
            >
                <div className="image-table-container">
                    <div className="image-table">
                        <div className="image-table-row">
                            <div className="image-table-cell image">Image </div>
                            <div className="image-table-cell url">Url </div>
                            <div className="image-table-cell file-size">File size</div>
                            <div className="image-table-cell potential-savings">Potential savings</div>
                        </div>

                        {unoptimizedImages.map((image, idx) => {
                            const formattedUrl = image.url.length <= 50 ? image.url : `...${image.url.slice(-50)}`;
                            return (
                                <div
                                    className="image-table-row"
                                    key={idx}
                                >
                                    <div className="image-table-cell image">
                                        <img
                                            src={image.url}
                                            alt=""
                                        />
                                    </div>
                                    <div className="image-table-cell url">
                                        <a
                                            href={image.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {formattedUrl}
                                        </a>
                                    </div>
                                    <div className="image-table-cell file-size">{(image.size / 1024).toFixed(1)} Kb</div>
                                    <div className="image-table-cell potential-savings">{(image.potential_savings / 1024).toFixed(1)} Kb</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </InlineModal>
        </div>
    );
}
